import { apiFetch } from "./apiFetch";

export async function verifyBrowserSession() {
  const response = await apiFetch(`${process.env.API_URL}/api/auth/me`);
  if (response.status === 401) throw new Error("Your browser did not retain the sign-in cookie. Check this site's cookie permissions and try again.");
  if (!response.ok) throw new Error("Could not verify your session. Please try again.");
  const data = await response.json();
  if (!data.user?.id) throw new Error("Could not verify your session. Please try again.");
  return data.user;
}
